// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1440px) {
  .container {
    max-width: 1200px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .container {
    max-width: 100%;
  }
}
@media screen and (max-width: 768px) {
  .searchResult {
    width: calc(100% - 40px);
  }
  .loginPopup {
    width: calc(100% - 40px);
  }
  .signUpPopup {
    width: calc(100% - 40px);
  }
  .whatsNewRibbon {
    font-size: 12px;
  }
}
@media screen and (min-width: 300px) and (max-width: 450px) {
  .creditCardInput input {
    height: 60px;
    font-size: 1rem;
  }
}
@media screen and (min-width: 451px) and (max-width: 768px) {
  .creditCardInput {
    gap: 1rem;
  }
  .creditCardInput input {
    font-size: 20px;
  }
}
@media screen and (max-width: 300px) {
  .react-tel-input .country-list {
    width: 200px !important;
  }
}
@media screen and (min-width: 301px) and (max-width: 450px) {
  .react-tel-input .country-list {
    width: 225px !important;
  }
}
@media (min-width: 451px) and (max-width: 768px) {
  .react-tel-input .country-list {
    width: 360px !important;
  }
}
@media screen and (max-width: 360px) {
  .experiencesRewardDetail .whatBenefitSingleCard {
    width: 280px !important;
  }
}
@media screen and (min-width: 361px) {
  .experiencesRewardDetail .whatBenefitSingleCard {
    width: 320px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Styles/CommonScss/responsive.scss"],"names":[],"mappings":"AACA;EACC;IACC,iBAAA;EAAA;AACF;AAGA;EACC;IACC,eAAA;EADA;AACF;AAMA;EACC;IACC,wBAAA;EAJA;EAOD;IACC,wBAAA;EALA;EAQD;IACC,wBAAA;EANA;EAcD;IACC,eAAA;EAVA;AAJF;AAoBA;EAEE;IACC,YAAA;IACA,eAAA;EAdD;AACF;AAkBA;EACC;IACC,SAAA;EAhBA;EAkBA;IACC,eAAA;EAhBD;AACF;AAsBA;EAEE;IACC,uBAAA;EArBD;AACF;AAyBA;EAEE;IACC,uBAAA;EAxBD;AACF;AA4BA;EAEE;IACC,uBAAA;EA3BD;AACF;AAiCA;EAEE;IACC,uBAAA;EAhCD;AACF;AAoCA;EAEE;IACC,uBAAA;EAnCD;AACF","sourcesContent":["@import \"src/Styles/theme.scss\";\n@media (min-width: 1440px) {\n\t.container {\n\t\tmax-width: 1200px;\n\t}\n}\n\n@media (min-width: 768px) and (max-width :1024px) {\n\t.container {\n\t\tmax-width: 100%;\n\t}\n}\n\n// Mobile Responsiveness Header\n\n@media screen and (max-width: 768px) {\n\t.searchResult {\n\t\twidth: calc(100% - 40px);\n\t}\n\n\t.loginPopup {\n\t\twidth: calc(100% - 40px);\n\t}\n\n\t.signUpPopup {\n\t\twidth: calc(100% - 40px);\n\t}\n\n}\n\n// Landing top banner responsiveness\n@media screen and (max-width: 768px) {\n\n\t.whatsNewRibbon {\n\t\tfont-size: 12px;\n\t}\n}\n\n// creditCard Input Responsive\n\n@media screen and (min-width:300px) and (max-width:450px) {\n\t.creditCardInput {\n\t\tinput {\n\t\t\theight: 60px;\n\t\t\tfont-size: 1rem;\n\t\t}\n\t}\n}\n\n@media screen and (min-width:451px) and (max-width:768px) {\n\t.creditCardInput {\n\t\tgap: 1rem;\n\n\t\tinput {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n}\n\n//Country Mobile Number Input Responsiveness\n\n@media screen and (max-width:300px) {\n\t.react-tel-input {\n\t\t.country-list {\n\t\t\twidth: 200px !important;\n\t\t}\n\t}\n}\n\n@media screen and (min-width:301px) and (max-width:450px) {\n\t.react-tel-input {\n\t\t.country-list {\n\t\t\twidth: 225px !important;\n\t\t}\n\t}\n}\n\n@media (min-width:451px) and (max-width:768px) {\n\t.react-tel-input {\n\t\t.country-list {\n\t\t\twidth: 360px !important;\n\t\t}\n\t}\n}\n\n// reward detail page whats benefit card responsiveness\n\n@media screen and (max-width:360px) {\n\t.experiencesRewardDetail {\n\t\t.whatBenefitSingleCard {\n\t\t\twidth: 280px !important;\n\t\t}\n\t}\n}\n\n@media screen and (min-width:361px) {\n\t.experiencesRewardDetail {\n\t\t.whatBenefitSingleCard {\n\t\t\twidth: 320px !important;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
